module.exports = __webpack_public_path__ + "img/maroon1.d4a9685f.png";